(function(){
  'use strict';
  var root=document.getElementById('sr');
  if(!root||root.dataset.srFormsReady==='true')return;

  function configureOptionalLink(selector,url){
    var link=root.querySelector(selector);
    if(!link)return;
    var destination=(url||'').trim();
    if(destination){
      link.href=destination;
      link.hidden=false;
      link.removeAttribute('aria-disabled');
    }else{
      link.removeAttribute('href');
      link.hidden=true;
      link.setAttribute('aria-disabled','true');
    }
  }

  configureOptionalLink('[data-sr-press-release]',root.dataset.pressReleaseUrl);
  configureOptionalLink('[data-sr-vote-link]',root.dataset.voteUrl);

  var endpoint=(root.getAttribute('data-form-endpoint')||'').trim();
  var siteKey=(root.getAttribute('data-turnstile-site-key')||'').trim();
  var supportedFormRoutes=['nonprofit','donor','bulk','intake','intake-finalize','intake-receipt','intake-hold','future','media','partner','contact','dispute','vote'];
  var enabledFormRoutes=(root.getAttribute('data-enabled-form-routes')||'').split(',').map(function(route){return route.trim().toLowerCase();}).filter(function(route,index,routes){return supportedFormRoutes.indexOf(route)!==-1&&routes.indexOf(route)===index;});

  function routeIsEnabled(route){
    return enabledFormRoutes.indexOf(String(route||'').trim().toLowerCase())!==-1;
  }

  function endpointIsValid(){
    if(!endpoint)return false;
    try{
      var url=new URL(endpoint);
      return url.protocol==='https:'&&url.hostname==='script.google.com'&&/\/macros\/s\/[^/]+\/exec$/.test(url.pathname);
    }catch(error){return false;}
  }

  function applyIntakeStatus(statusOverride,usedOverride){
    var status=(statusOverride||root.dataset.intakeStatus||'scheduled').toLowerCase();
    var rawUsed=usedOverride==null?root.dataset.capacityUsed:usedOverride;
    var used=Math.max(0,Math.min(1000,parseInt(rawUsed||'0',10)||0));
    var remaining=Math.max(0,1000-used);
    var states={
      scheduled:{label:'Open now',detail:'Apply or preregister by Oct. 23. Public sign drop-off begins Nov. 9.'},
      open:{label:'Accepting qualifying panels',detail:remaining+' of 1,000 custody spaces remain. Counts update after completed intake records.'},
      limited:{label:'Limited capacity',detail:remaining+' of 1,000 custody spaces remain. Confirm status before transporting a load.'},
      closed:{label:'Intake closed',detail:'The 1,000-panel custody limit has been reached. Do not transport additional signs.'}
    };
    var state=states[status]||states.scheduled;
    root.dataset.intakeStatus=status;
    root.dataset.capacityUsed=String(used);
    var label=root.querySelector('[data-sr-intake-status-label]');
    var detail=root.querySelector('[data-sr-intake-status-detail]');
    if(label)label.textContent=state.label;
    if(detail)detail.textContent=state.detail;
    root.dataset.intakeClosed=status==='closed'?'true':'false';
    Array.prototype.forEach.call(root.querySelectorAll('[data-sr-intake-action]'),function(action){
      if(status==='closed'){
        if(!action.disabled)action.dataset.srCapacityDisabled='true';
        action.disabled=true;
        action.setAttribute('aria-disabled','true');
        action.setAttribute('title','Intake is closed because the 1,000-panel custody limit has been reached.');
      }else if(action.dataset.srCapacityDisabled==='true'){
        action.disabled=false;
        delete action.dataset.srCapacityDisabled;
        action.removeAttribute('aria-disabled');
        action.removeAttribute('title');
      }
    });
  }

  applyIntakeStatus();

  function refreshIntakeStatus(){
    if(!endpointIsValid())return;
    var configuredStatus=(root.dataset.intakeStatus||'scheduled').toLowerCase();
    fetch(endpoint+'?mode=intake_capacity',{method:'GET',cache:'no-store',credentials:'omit'})
      .then(function(response){if(!response.ok)throw new Error('capacity_unavailable');return response.json();})
      .then(function(data){
        if(!data||data.ok!==true||typeof data.physical_panels!=='number'||typeof data.remaining_panels!=='number'||typeof data.intake_open!=='boolean')throw new Error('capacity_invalid');
        var nextStatus=configuredStatus;
        if(!data.intake_open)nextStatus='closed';
        else if(configuredStatus==='open'||configuredStatus==='limited')nextStatus=data.remaining_panels<=100?'limited':'open';
        applyIntakeStatus(nextStatus,data.physical_panels);
      })
      .catch(function(){/* Preserve the verified theme fallback when the live status service is unavailable. */});
  }

  refreshIntakeStatus();
  root.dataset.srFormsReady='true';

  var dialog=document.getElementById('sr-program-dialog');
  var title=document.getElementById('sr-dialog-title');
  var intro=document.getElementById('sr-dialog-intro');
  var availabilityNotice=dialog.querySelector('[data-sr-availability-notice]');
  var forms=Array.prototype.slice.call(dialog.querySelectorAll('[data-sr-form]'));
  var legacyForms=forms.filter(function(form){return form.tagName==='FORM';});
  var lastTrigger=null;
  var activeForm=null;
  var previousBodyOverflow='';
  var submitTimers={};
  var turnstileLoadPromise=null;
  var query=new URLSearchParams(window.location.search);
  var pendingIntakeStorageKey='sr_pending_intake_v2';
  var pendingReceiptStorageKey='sr_pending_receipt_v2';
  var receiptContractVersion='SR-RECEIPT-2026-10-08-v1';
  var receiptDisclaimer='This receipt documents the handoff record. It is not a charitable tax receipt, does not prove that every accepted panel became a finished sign and does not resolve legal title.';
  var productionParentOrigins=['https://760print.com','https://www.760print.com'];
  var trustedParentOrigin=productionParentOrigins.indexOf(window.location.origin)!==-1?window.location.origin:'';
  var trustedGoogleResultOrigin=function(origin){
    return origin==='https://script.google.com'||/^https:\/\/[^/]+\.googleusercontent\.com$/.test(origin);
  };

  function analytics(name,params){
    var payload={};
    Object.keys(params||{}).forEach(function(key){
      var value=params[key];
      if(typeof value==='string'&&/^[a-z0-9_+-]{1,80}$/i.test(value))payload[key]=value;
    });
    if(typeof window.gtag==='function'){
      window.gtag('event',name,payload);
      return;
    }
    payload.event=name;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(payload);
  }

  function setupRoleSwitcher(){
    var switcher=root.querySelector('[data-sr-role-switcher]');
    if(!switcher)return;
    var tabs=Array.prototype.slice.call(switcher.querySelectorAll('[role="tab"]'));
    var panels=Array.prototype.slice.call(switcher.querySelectorAll('[role="tabpanel"]'));
    if(!tabs.length||!panels.length)return;

    function activate(tab,moveFocus,track){
      var panelId=tab.getAttribute('aria-controls');
      tabs.forEach(function(item){
        var selected=item===tab;
        item.setAttribute('aria-selected',selected?'true':'false');
        item.tabIndex=selected?0:-1;
      });
      panels.forEach(function(panel){panel.hidden=panel.id!==panelId;});
      if(moveFocus)tab.focus();
      if(track)analytics('sr_audience_select',{audience:tab.dataset.srRole||'unknown'});
    }

    tabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){activate(tab,false,true);});
      tab.addEventListener('keydown',function(event){
        var next=index;
        if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(index+1)%tabs.length;
        else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(index-1+tabs.length)%tabs.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=tabs.length-1;
        else return;
        event.preventDefault();
        activate(tabs[next],true,true);
      });
    });
    var hashRole=(window.location.hash||'').replace('#sr-role-','');
    var initial=tabs.find(function(tab){return tab.dataset.srRole===hashRole;})||tabs.find(function(tab){return tab.getAttribute('aria-selected')==='true';})||tabs[0];
    activate(initial,false,false);
  }

  setupRoleSwitcher();

  function revealDisclosure(target){
    var current=target;
    while(current&&current!==root){
      if(current.tagName==='DETAILS')current.open=true;
      current=current.parentElement;
    }
  }

  function preferredScrollBehavior(){
    return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
  }

  function revealHashTarget(hash,moveFocus){
    if(!hash||hash.charAt(0)!=='#')return false;
    var target=document.getElementById(hash.slice(1));
    if(!target||!root.contains(target))return false;
    revealDisclosure(target);
    target.scrollIntoView({behavior:preferredScrollBehavior(),block:'start'});
    if(moveFocus){
      window.setTimeout(function(){
        var focusTarget=target.tagName==='DETAILS'?target.querySelector(':scope>summary'):target;
        if(focusTarget&&typeof focusTarget.focus==='function')focusTarget.focus({preventScroll:true});
      },350);
    }
    return true;
  }

  if(window.location.hash)revealDisclosure(document.getElementById(window.location.hash.slice(1)));

  function variantParams(form,extra){
    var params={form_type:form.dataset.formType,form_variant:form.dataset.analyticsVariant||form.dataset.srForm,workflow_scope:form.dataset.srStaffWorkflow==='true'?'staff':'public'};
    if(form.dataset.intakeStage)params.intake_stage=form.dataset.intakeStage;
    Object.keys(extra||{}).forEach(function(key){params[key]=extra[key];});
    return params;
  }

  function contactType(form){
    var declared=(form.dataset.contactType||'').trim();
    if(declared)return declared;
    var inquiry=form.querySelector('[name="inquiry_type"]');
    var value=inquiry?(inquiry.value||'').toLowerCase():'';
    if(value.indexOf('media')!==-1)return 'media_request';
    if(value.indexOf('community')!==-1||value.indexOf('campaign')!==-1)return 'community_partner';
    if(value.indexOf('vot')!==-1)return 'vote_reminder';
    if(value.indexOf('printing')!==-1)return 'printing_inquiry';
    return 'general_question';
  }

  function makeSubmissionId(){
    if(window.crypto&&typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID();
    var bytes=new Uint8Array(24);
    if(window.crypto&&window.crypto.getRandomValues)window.crypto.getRandomValues(bytes);
    else for(var i=0;i<bytes.length;i+=1)bytes[i]=Math.floor(Math.random()*256);
    return Array.prototype.map.call(bytes,function(value){return value.toString(16).padStart(2,'0');}).join('');
  }

  function hiddenField(form,name,value){
    var field=form.querySelector('input[type="hidden"][name="'+name+'"]');
    if(!field){
      field=document.createElement('input');
      field.type='hidden';
      field.name=name;
      form.appendChild(field);
    }
    field.value=value==null?'':String(value);
    return field;
  }

  function invalidatePendingAttempt(form){
    window.clearTimeout(submitTimers[form.id]);
    delete submitTimers[form.id];
    delete form.dataset.pendingAttemptId;
  }

  function prepareForm(form,ctaLocation){
    var completed=form.dataset.completed==='true';
    invalidatePendingAttempt(form);
    if(completed){
      form.reset();
      Array.prototype.forEach.call(form.elements,function(field){field.disabled=false;});
      resetTurnstile(form);
      delete form.dataset.completed;
    }
    var continueFinalize=form.querySelector('[data-sr-continue-finalize]');
    if(continueFinalize)continueFinalize.hidden=true;
    var continueReceipt=form.querySelector('[data-sr-continue-receipt]');
    if(continueReceipt)continueReceipt.hidden=true;
    var receiptSummary=form.querySelector('[data-sr-receipt-summary]');
    if(receiptSummary)receiptSummary.hidden=true;
    form._srOpenedAt=performance.now();
    form.dataset.started='false';
    form.dataset.ctaLocation=ctaLocation||'unknown';
    hiddenField(form,'response_mode','html');
    hiddenField(form,'form_route',form.dataset.srForm||'');
    var existingSubmission=form.querySelector('[name="submission_id"]');
    var staffTransition=['finalize','receipt_delivery','ownership_dispute_hold'].indexOf(form.dataset.intakeStage)!==-1;
    if(!staffTransition&&(completed||!existingSubmission||!existingSubmission.value))hiddenField(form,'submission_id',makeSubmissionId());
    if(form.dataset.intakeStage==='finalize')restorePendingIntake(form);
    if(form.dataset.intakeStage==='receipt_delivery')restorePendingReceipt(form);
    if(form.dataset.intakeStage==='ownership_dispute_hold'){
      var transitionId=form.querySelector('[name="transition_id"]');
      if(transitionId&&(completed||!transitionId.value))transitionId.value=makeSubmissionId();
    }
    hiddenField(form,'form_elapsed_ms','0');
    hiddenField(form,'source_page',window.location.pathname);
    hiddenField(form,'utm_source',query.get('utm_source')||'');
    hiddenField(form,'utm_medium',query.get('utm_medium')||'');
    hiddenField(form,'utm_campaign',query.get('utm_campaign')||'');
    hiddenField(form,'referrer',document.referrer||'');
    hiddenField(form,'parent_origin',trustedParentOrigin);
    form.action=endpoint||window.location.href;
    clearErrors(form);
    setStatus(form,'','');
    var submit=form.querySelector('[type="submit"]');
    if(submit)submit.disabled=false;
  }

  function savePendingIntake(loadId,presentedPanels){
    if(!loadId)return;
    var record={load_id:loadId,presented_panels:String(presentedPanels||'')};
    try{window.sessionStorage.setItem(pendingIntakeStorageKey,JSON.stringify(record));}catch(error){}
    var finalForm=dialog.querySelector('[data-sr-form="intake-finalize"]');
    if(!finalForm)return;
    var idField=finalForm.querySelector('[name="submission_id"]');
    var presentedField=finalForm.querySelector('[name="presented_panels"]');
    if(idField)idField.value=record.load_id;
    if(presentedField)presentedField.value=record.presented_panels;
  }

  function restorePendingIntake(form){
    if(!form||form.dataset.intakeStage!=='finalize')return;
    var record=null;
    try{record=JSON.parse(window.sessionStorage.getItem(pendingIntakeStorageKey)||'null');}catch(error){}
    if(!record)return;
    var idField=form.querySelector('[name="submission_id"]');
    var presentedField=form.querySelector('[name="presented_panels"]');
    if(idField&&!idField.value)idField.value=record.load_id||'';
    if(presentedField&&!presentedField.value)presentedField.value=record.presented_panels||'';
  }

  function clearPendingIntake(){
    try{window.sessionStorage.removeItem(pendingIntakeStorageKey);}catch(error){}
  }

  function normalizedReceiptCounts(counts){
    var normalized={};
    ['presented_panels','accepted_panels','declined_returned_panels','over_cap_panels','held_panels'].forEach(function(key){
      var value=counts&&counts[key];
      if(typeof value==='number'&&Number.isInteger(value)&&value>=0)normalized[key]=value;
    });
    return normalized;
  }

  function normalizedReceiptText(value,maxLength){
    return typeof value==='string'?value.trim().slice(0,maxLength):'';
  }

  function normalizedReceiptRecord(data){
    if(!data||data.receipt_contract_version!==receiptContractVersion)return null;
    var counts=normalizedReceiptCounts(data.authoritative_counts);
    var countKeys=['presented_panels','accepted_panels','declined_returned_panels','over_cap_panels','held_panels'];
    if(countKeys.some(function(key){return !Object.prototype.hasOwnProperty.call(counts,key);})){return null;}
    if(counts.presented_panels!==counts.accepted_panels+counts.declined_returned_panels+counts.over_cap_panels+counts.held_panels)return null;
    var record={
      receipt_contract_version:receiptContractVersion,
      receipt_id:normalizedReceiptText(data.receipt_id,36),
      load_id:normalizedReceiptText(data.load_id,100),
      finalized_at:normalizedReceiptText(data.finalized_at instanceof Date?data.finalized_at.toISOString():data.finalized_at,100),
      owner_or_authorizer:normalizedReceiptText(data.owner_or_authorizer,240),
      intake_status:normalizedReceiptText(data.intake_status,80),
      stack_reference:normalizedReceiptText(data.stack_reference,160),
      receipt_disclaimer:normalizedReceiptText(data.receipt_disclaimer,500),
      authoritative_counts:counts
    };
    var allowedStatuses=['Accepted into custody','Declined and returned','Partially accepted','Ownership dispute hold'];
    if(!/^SRR-[A-F0-9]{32}$/.test(record.receipt_id)||!/^[A-Za-z0-9_-]{12,100}$/.test(record.load_id)||!record.finalized_at||Number.isNaN(Date.parse(record.finalized_at))||!record.owner_or_authorizer||allowedStatuses.indexOf(record.intake_status)===-1||record.receipt_disclaimer!==receiptDisclaimer)return null;
    if(counts.accepted_panels+counts.held_panels>0&&!record.stack_reference)return null;
    return record;
  }

  function formatReceiptTimestamp(value){
    var date=new Date(value);
    if(Number.isNaN(date.getTime()))return value||'';
    try{
      return new Intl.DateTimeFormat('en-US',{year:'numeric',month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZone:'America/Los_Angeles',timeZoneName:'short'}).format(date);
    }catch(error){
      return date.toLocaleString('en-US',{timeZone:'America/Los_Angeles'});
    }
  }

  function populateReceiptSummary(form,receiptData){
    if(!form)return;
    var summary=form.querySelector('[data-sr-receipt-summary]');
    if(!summary)return;
    var record=normalizedReceiptRecord(receiptData);
    var number=summary.querySelector('[data-sr-receipt-number]');
    if(number)number.textContent=record&&record.receipt_id||'';
    var counts=record&&record.authoritative_counts||{};
    var complete=Boolean(record);
    Array.prototype.forEach.call(summary.querySelectorAll('[data-sr-receipt-field]'),function(node){
      var key=node.dataset.srReceiptField;
      if(!record||!Object.prototype.hasOwnProperty.call(record,key))complete=false;
      var value=record&&Object.prototype.hasOwnProperty.call(record,key)?record[key]:'';
      if(key==='finalized_at'){
        if(node.tagName==='TIME')node.dateTime=value;
        value=formatReceiptTimestamp(value);
      }else if(key==='stack_reference'&&!value){
        value='Not applicable, no panels accepted';
      }
      node.textContent=value;
    });
    Array.prototype.forEach.call(summary.querySelectorAll('[data-sr-receipt-count]'),function(node){
      var key=node.dataset.srReceiptCount;
      if(!Object.prototype.hasOwnProperty.call(counts,key))complete=false;
      node.textContent=Object.prototype.hasOwnProperty.call(counts,key)?counts[key]:'0';
    });
    var disclaimer=summary.querySelector('[data-sr-receipt-disclaimer]');
    if(disclaimer)disclaimer.textContent=record&&record.receipt_disclaimer||'';
    summary.hidden=!(record&&record.receipt_id&&complete);
    return !summary.hidden;
  }

  function savePendingReceipt(receiptData){
    var record=normalizedReceiptRecord(receiptData);
    if(!record)return false;
    try{window.sessionStorage.setItem(pendingReceiptStorageKey,JSON.stringify(record));}catch(error){}
    var receiptForm=dialog.querySelector('[data-sr-form="intake-receipt"]');
    if(!receiptForm)return true;
    receiptForm._srPendingReceipt=record;
    var idField=receiptForm.querySelector('[name="submission_id"]');
    var receiptField=receiptForm.querySelector('[name="receipt_id"]');
    var versionField=receiptForm.querySelector('[name="receipt_contract_version"]');
    if(idField)idField.value=record.load_id;
    if(receiptField)receiptField.value=record.receipt_id;
    if(versionField)versionField.value=record.receipt_contract_version;
    populateReceiptSummary(receiptForm,record);
    return true;
  }

  function restorePendingReceipt(form){
    if(!form||form.dataset.intakeStage!=='receipt_delivery')return;
    var record=form._srPendingReceipt||null;
    if(!record)try{record=JSON.parse(window.sessionStorage.getItem(pendingReceiptStorageKey)||'null');}catch(error){}
    record=normalizedReceiptRecord(record);
    if(!record){try{window.sessionStorage.removeItem(pendingReceiptStorageKey);}catch(error){}return;}
    form._srPendingReceipt=record;
    var idField=form.querySelector('[name="submission_id"]');
    var receiptField=form.querySelector('[name="receipt_id"]');
    var versionField=form.querySelector('[name="receipt_contract_version"]');
    if(idField&&!idField.value)idField.value=record.load_id||'';
    if(receiptField&&!receiptField.value)receiptField.value=record.receipt_id||'';
    if(versionField&&!versionField.value)versionField.value=record.receipt_contract_version||'';
    populateReceiptSummary(form,record);
  }

  function clearPendingReceipt(){
    try{window.sessionStorage.removeItem(pendingReceiptStorageKey);}catch(error){}
    var receiptForm=dialog.querySelector('[data-sr-form="intake-receipt"]');
    if(receiptForm)delete receiptForm._srPendingReceipt;
  }

  function setStatus(form,message,state){
    var status=form.querySelector('.sr-form__status');
    if(!status)return;
    status.textContent=message||'';
    status.dataset.state=state||'';
    status.hidden=!message;
  }

  function clearErrors(form){
    var box=form.querySelector('.sr-form__errors');
    if(box)box.replaceChildren();
    Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid="true"]'),function(field){field.removeAttribute('aria-invalid');});
  }

  function errorLabel(field){
    var label=field.id?formLabel(field.form,field.id):'';
    var wrapper=field.closest('label');
    return label||(wrapper?wrapper.textContent.trim():'')||field.getAttribute('aria-label')||field.name||'Required field';
  }

  function formLabel(form,id){
    var label=form.querySelector('label[for="'+id+'"]');
    return label?label.textContent.replace('*','').trim():'';
  }

  function showValidationErrors(form,extraMessage){
    clearErrors(form);
    var invalid=[];
    Array.prototype.forEach.call(form.elements,function(field){
      if(field.willValidate&&!field.checkValidity())invalid.push(field);
    });
    var box=form.querySelector('.sr-form__errors');
    if(!box)return invalid.length===0&&!extraMessage;
    if(invalid.length||extraMessage){
      var heading=document.createElement('strong');
      heading.textContent='Please review the highlighted information.';
      box.appendChild(heading);
      var list=document.createElement('ul');
      invalid.forEach(function(field){
        field.setAttribute('aria-invalid','true');
        var item=document.createElement('li');
        var link=document.createElement('a');
        link.href='#'+field.id;
        link.textContent=errorLabel(field)+': '+field.validationMessage;
        link.addEventListener('click',function(event){event.preventDefault();field.focus();});
        item.appendChild(link);
        list.appendChild(item);
      });
      if(extraMessage){
        var extra=document.createElement('li');
        extra.textContent=extraMessage;
        list.appendChild(extra);
      }
      box.appendChild(list);
      box.focus({preventScroll:true});
      box.scrollIntoView({behavior:preferredScrollBehavior(),block:'nearest'});
    }
    return invalid.length===0&&!extraMessage;
  }

  function turnstileConfigured(){
    return siteKey&&siteKey!=='REPLACE_WITH_PUBLIC_SITE_KEY'&&!/^REPLACE_/i.test(siteKey);
  }

  function loadTurnstile(){
    if(window.turnstile)return Promise.resolve(window.turnstile);
    if(turnstileLoadPromise)return turnstileLoadPromise;
    turnstileLoadPromise=new Promise(function(resolve,reject){
      var script=document.createElement('script');
      script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async=true;
      script.defer=true;
      script.onload=function(){window.turnstile?resolve(window.turnstile):reject(new Error('turnstile_unavailable'));};
      script.onerror=function(){reject(new Error('turnstile_unavailable'));};
      document.head.appendChild(script);
    });
    return turnstileLoadPromise;
  }

  function renderTurnstile(form){
    if(!endpoint||!turnstileConfigured())return;
    var slot=form.querySelector('[data-turnstile-slot]');
    if(!slot||form.dataset.turnstileWidgetId)return;
    loadTurnstile().then(function(api){
      if(form.dataset.turnstileWidgetId)return;
      slot.replaceChildren();
      var widgetId=api.render(slot,{sitekey:siteKey,action:'signs_reassigned_submit',theme:'light'});
      form.dataset.turnstileWidgetId=String(widgetId);
    }).catch(function(){
      slot.innerHTML='<p class="sr-turnstile__setup">Verification could not load. Check your connection and try again.</p>';
    });
  }

  function resetTurnstile(form){
    if(window.turnstile&&form.dataset.turnstileWidgetId)window.turnstile.reset(form.dataset.turnstileWidgetId);
  }

  function loadGoogleForm(panel){
    var frame=panel.querySelector('[data-sr-google-form-frame]');
    var loading=panel.querySelector('[data-sr-google-form-loading]');
    if(!frame)return;
    if(frame.dataset.srLoaded!=='true'){
      frame.addEventListener('load',function(){if(loading)loading.hidden=true;},{once:true});
      frame.src=frame.dataset.src;
      frame.dataset.srLoaded='true';
    }
    frame.hidden=false;
  }

  function openForm(key,trigger){
    var form=dialog.querySelector('[data-sr-form="'+key+'"]');
    if(!form)return;
    var googleForm=form.dataset.srGoogleForm==='true';
    var formReady=googleForm||(endpointIsValid()&&turnstileConfigured()&&routeIsEnabled(key));
    lastTrigger=trigger||document.activeElement;
    activeForm=form;
    forms.forEach(function(item){item.hidden=!formReady||item!==form;});
    title.textContent=form.dataset.title;
    intro.textContent=formReady?form.dataset.intro:'Use the verified phone number or email below for this program action.';
    availabilityNotice.hidden=formReady;
    if(googleForm)loadGoogleForm(form);
    else if(formReady)prepareForm(form,trigger&&trigger.dataset.ctaLocation?trigger.dataset.ctaLocation:'unknown');
    if(typeof dialog.showModal==='function'&&!dialog.open)dialog.showModal();
    else dialog.setAttribute('open','');
    previousBodyOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    document.documentElement.classList.add('sr-dialog-open');
    analytics('sr_form_open',variantParams(form));
    if(formReady)renderTurnstile(form);
    window.setTimeout(function(){
      var first=googleForm?form.querySelector('[data-sr-google-form-frame]'):formReady?form.querySelector('input:not([type="hidden"]):not([tabindex="-1"]),select,textarea,button'):availabilityNotice.querySelector('a');
      if(first)first.focus();
    },30);
  }

  function closeDialog(){
    if(dialog.open&&typeof dialog.close==='function')dialog.close();
    else dialog.removeAttribute('open');
    document.body.style.overflow=previousBodyOverflow;
    document.documentElement.classList.remove('sr-dialog-open');
    forms.forEach(function(form){form.hidden=true;});
    activeForm=null;
    if(lastTrigger&&typeof lastTrigger.focus==='function')lastTrigger.focus();
  }

  root.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-sr-open]');
    if(trigger&&root.contains(trigger)){
      event.preventDefault();
      openForm(trigger.dataset.srOpen,trigger);
      return;
    }
    var detailTrigger=event.target.closest('[data-sr-detail-link]');
    if(detailTrigger){
      var detailHash=detailTrigger.getAttribute('href')||'';
      if(revealHashTarget(detailHash,true))event.preventDefault();
      return;
    }
    var rulesTrigger=event.target.closest('[data-sr-reveal-rules]');
    if(rulesTrigger){
      if(revealHashTarget('#full-rules',true))event.preventDefault();
      return;
    }
    if(event.target.closest('[data-sr-close]')){
      event.preventDefault();
      closeDialog();
    }
  });

  var requestedAction=(query.get('action')||'').trim();
  var deepLinkActions=['nonprofit','donor','bulk','future','media','partner','contact','dispute','vote'];
  if(deepLinkActions.indexOf(requestedAction)!==-1){
    window.setTimeout(function(){openForm(requestedAction,{dataset:{ctaLocation:'deep_link'}});},0);
  }
  var requestedStaffAction=(query.get('staff_action')||'').trim();
  if(requestedStaffAction==='ownership-dispute-hold'){
    window.setTimeout(function(){openForm('intake-hold',{dataset:{ctaLocation:'staff_deep_link'}});},0);
  }else if(requestedStaffAction==='receipt-delivery'){
    window.setTimeout(function(){openForm('intake-receipt',{dataset:{ctaLocation:'staff_deep_link'}});},0);
  }

  dialog.addEventListener('cancel',function(event){event.preventDefault();closeDialog();});
  dialog.addEventListener('click',function(event){
    if(event.target!==dialog)return;
    var rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeDialog();
  });
  dialog.addEventListener('keydown',function(event){
    if(event.key==='Escape'){event.preventDefault();closeDialog();return;}
    if(event.key!=='Tab')return;
    var focusable=Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(node){return !node.closest('[hidden]');});
    if(!focusable.length)return;
    var first=focusable[0];
    var last=focusable[focusable.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });

  function applyConditionalValidation(form){
    var estimatedCount=form.querySelector('[name="expected_panel_count"]');
    var donorEvidence=form.querySelector('[name="evidence_reference"]');
    if(estimatedCount&&donorEvidence&&form.dataset.formType==='donor'){
      donorEvidence.setCustomValidity(Number(estimatedCount.value)>=40&&!donorEvidence.value.trim()?'Provide the supporting authority record for a projected load of 40 or more panels.':'');
    }
    var appointmentRequest=form.querySelector('[name="bulk_appointment_requested"]');
    if(estimatedCount&&appointmentRequest&&form.dataset.srForm==='donor'){
      appointmentRequest.setCustomValidity(Number(estimatedCount.value)>=40&&!appointmentRequest.checked?'Request a bulk appointment for a projected load of 40 or more panels.':'');
    }

    if(form.dataset.intakeStage==='certification'){
      var presented=form.querySelector('[name="presented_panels"]');
      var authority=form.querySelector('[name="authority_basis"]');
      var source=form.querySelector('[name="source_category"]');
      var evidence=form.querySelector('[name="evidence_reference"]');
      var documentedAuthority=['Written authorization from owner','Property controller with transfer authorization','Government agency or authorized contractor','Other documented authority'];
      var documentedSource=['Agency transfer','Other documented source'];
      var evidenceRequired=Number(presented&&presented.value)>=40||documentedAuthority.indexOf(authority&&authority.value)!==-1||documentedSource.indexOf(source&&source.value)!==-1;
      if(evidence)evidence.setCustomValidity(evidenceRequired&&!evidence.value.trim()?'Provide the supporting authority record for this load.':'');

      var channel=form.querySelector('[name="intake_channel"]');
      var paperFallback=form.querySelector('[data-paper-fallback]');
      var paperReference=form.querySelector('[data-paper-reference]');
      var paperSigned=form.querySelector('[data-paper-signed]');
      var paperRequired=Boolean(channel&&channel.value==='Paper reconciliation'||paperFallback&&paperFallback.checked);
      if(paperReference)paperReference.setCustomValidity(paperRequired&&!paperReference.value.trim()?'Enter the paper record reference.':'');
      if(paperSigned)paperSigned.setCustomValidity(paperRequired&&!paperSigned.value?'Enter when the paper certification was signed.':'');
    }

    if(form.dataset.intakeStage==='finalize'){
      var presentedFinal=Number((form.querySelector('[name="presented_panels"]')||{}).value);
      var acceptedField=form.querySelector('[name="accepted_panels"]');
      var declinedField=form.querySelector('[name="declined_returned_panels"]');
      var overCapField=form.querySelector('[name="over_cap_panels"]');
      var accepted=Number(acceptedField&&acceptedField.value);
      var declined=Number(declinedField&&declinedField.value);
      var overCap=Number(overCapField&&overCapField.value);
      var countsPresent=acceptedField&&acceptedField.value!==''&&declinedField&&declinedField.value!==''&&overCapField&&overCapField.value!=='';
      var mismatch=countsPresent&&accepted+declined+overCap!==presentedFinal;
      if(overCapField)overCapField.setCustomValidity(mismatch?'Accepted, declined and over-cap panels must equal the certified presented quantity.':'');
      var declineReasons=Array.prototype.slice.call(form.querySelectorAll('[name="decline_reason_codes"]'));
      var selectedDeclineReasons=declineReasons.filter(function(field){return field.checked;});
      if(declineReasons.length){
        declineReasons[0].setCustomValidity(declined>0&&!selectedDeclineReasons.length?'Select at least one decline reason for declined panels.':declined===0&&selectedDeclineReasons.length?'Remove decline reasons when no panels were declined.':'');
      }
      var declineNotes=form.querySelector('[name="decline_reason_notes"]');
      var otherReasonSelected=selectedDeclineReasons.some(function(field){return field.value==='other_documented_reason';});
      if(declineNotes)declineNotes.setCustomValidity(otherReasonSelected&&!declineNotes.value.trim()?'Describe the other documented decline reason.':declined===0&&declineNotes.value.trim()?'Remove decline reason notes when no panels were declined.':'');
      var stack=form.querySelector('[name="stack_location"]');
      if(stack)stack.setCustomValidity(accepted>0&&!stack.value.trim()?'Enter the stack location for accepted panels.':'');
    }

    if(form.dataset.intakeStage==='receipt_delivery'){
      var pendingReceipt=normalizedReceiptRecord(form._srPendingReceipt);
      var receiptIdField=form.querySelector('[name="receipt_id"]');
      var receiptLoadIdField=form.querySelector('[name="submission_id"]');
      var receiptVersionField=form.querySelector('[name="receipt_contract_version"]');
      var receiptMatches=Boolean(pendingReceipt&&receiptIdField&&receiptLoadIdField&&receiptVersionField&&pendingReceipt.receipt_id===receiptIdField.value.trim()&&pendingReceipt.load_id===receiptLoadIdField.value.trim()&&pendingReceipt.receipt_contract_version===receiptVersionField.value.trim());
      if(receiptIdField)receiptIdField.setCustomValidity(receiptMatches?'':'Open receipt handoff from a confirmed finalization response so the complete receipt can be shown.');
    }
  }

  legacyForms.forEach(function(form){
    var errorBox=form.querySelector('.sr-form__errors');
    if(errorBox)errorBox.setAttribute('tabindex','-1');
    Array.prototype.forEach.call(form.elements,function(field,index){
      if(!field.id&&field.name)field.id='sr-'+form.dataset.srForm+'-'+field.name.replace(/[^a-z0-9_-]/gi,'-')+'-'+index;
    });
    ['input','change'].forEach(function(eventName){
      form.addEventListener(eventName,function(event){
        var field=event.target;
        if(form.dataset.started==='true'||field.type==='hidden'||field.name==='website_confirm')return;
        form.dataset.started='true';
        analytics('sr_form_start',variantParams(form));
      },true);
    });

    form.addEventListener('submit',function(event){
      if(!routeIsEnabled(form.dataset.srForm)){
        event.preventDefault();
        setStatus(form,'Online submissions are temporarily unavailable. Nothing was sent. Call (760) 758-1140 or email sales@760print.com for help.','error');
        analytics('sr_form_error',variantParams(form,{error_code:'form_route_disabled'}));
        return;
      }
      var recovery=form.querySelector('[data-recovery-opt-in]');
      var permission=form.querySelector('[data-public-name-permission]');
      var nominee=form.querySelector('[name="nominated_nonprofit_name"]');
      var nomineeCounty=form.querySelector('[name="nominated_nonprofit_county_presence"]');
      var nomineeConsent=form.querySelector('[name="nominated_nonprofit_consent_confirmed"]');
      var estimatedCount=form.querySelector('[name="expected_panel_count"]');
      var nomineeNamed=Boolean(nominee&&nominee.value.trim());
      if(permission)permission.setCustomValidity(recovery&&recovery.checked&&!permission.checked?'Authorize public naming to join the optional Recovery Commitment.':'');
      if(nomineeCounty)nomineeCounty.setCustomValidity(nomineeNamed&&!nomineeCounty.checked?'Confirm the nominee serves San Diego County, or remove the nominee.':'');
      if(nomineeConsent)nomineeConsent.setCustomValidity(nomineeNamed&&!nomineeConsent.checked?'Confirm the nonprofit agreed to be nominated, or remove the nominee.':'');
      if(nominee)nominee.setCustomValidity(nomineeNamed&&estimatedCount&&Number(estimatedCount.value)<40?'A nonprofit nomination requires an expected contribution of at least 40 panels. Remove the nominee or update the estimate.':'');
      applyConditionalValidation(form);
      if(!showValidationErrors(form,'')){
        event.preventDefault();
        analytics('sr_form_error',variantParams(form,{error_code:'client_validation'}));
        return;
      }
      if(!endpoint){
        event.preventDefault();
        setStatus(form,'Online submissions are temporarily unavailable. Nothing was sent. Call (760) 758-1140 or email sales@760print.com for help.','error');
        analytics('sr_form_error',variantParams(form,{error_code:'endpoint_not_configured'}));
        return;
      }
      if(!endpointIsValid()){
        event.preventDefault();
        setStatus(form,'The configured form endpoint is not a valid Apps Script production URL. Nothing was sent.','error');
        analytics('sr_form_error',variantParams(form,{error_code:'endpoint_invalid'}));
        return;
      }
      if(!trustedParentOrigin){
        event.preventDefault();
        setStatus(form,'This form can submit only from the official 760 Print website. Nothing was sent.','error');
        analytics('sr_form_error',variantParams(form,{error_code:'parent_origin_not_allowed'}));
        return;
      }
      if(!turnstileConfigured()){
        event.preventDefault();
        setStatus(form,'Bot verification is not configured, so this request was not sent.','error');
        analytics('sr_form_error',variantParams(form,{error_code:'verification_not_configured'}));
        return;
      }
      if(!form.querySelector('[name="cf-turnstile-response"]')||!form.querySelector('[name="cf-turnstile-response"]').value){
        event.preventDefault();
        showValidationErrors(form,'Complete the bot verification before sending.');
        analytics('sr_form_error',variantParams(form,{error_code:'verification_required'}));
        return;
      }
      var attemptId=makeSubmissionId();
      hiddenField(form,'attempt_id',attemptId);
      form.dataset.pendingAttemptId=attemptId;
      hiddenField(form,'form_elapsed_ms',Math.max(0,Math.round(performance.now()-form._srOpenedAt)));
      form.action=endpoint;
      var submit=form.querySelector('[type="submit"]');
      if(submit)submit.disabled=true;
      setStatus(form,'Sending your request. Keep this window open until confirmation appears.','pending');
      analytics('sr_form_submit',variantParams(form));
      window.clearTimeout(submitTimers[form.id]);
      submitTimers[form.id]=window.setTimeout(function(){
        if(form.dataset.pendingAttemptId!==attemptId)return;
        invalidatePendingAttempt(form);
        if(submit)submit.disabled=false;
        resetTurnstile(form);
        setStatus(form,'A confirmed response was not received. Your request is not marked as sent. Please try again.','error');
        analytics('sr_form_error',variantParams(form,{error_code:'response_timeout'}));
      },30000);
    });
  });

  window.addEventListener('message',function(event){
    if(!trustedGoogleResultOrigin(event.origin)||!event.data||event.data.source!=='signs-reassigned-forms')return;
    var matchedForm=null;
    legacyForms.some(function(form){
      var frame=document.getElementById('sr-result-'+form.dataset.srForm);
      if(frame&&event.source===frame.contentWindow){matchedForm=form;return true;}
      return false;
    });
    if(!matchedForm||event.data.form_type&&event.data.form_type!==matchedForm.dataset.formType)return;
    var pendingAttemptId=matchedForm.dataset.pendingAttemptId||'';
    if(!pendingAttemptId||event.data.attempt_id!==pendingAttemptId)return;
    if(event.data.parent_origin&&event.data.parent_origin!==trustedParentOrigin)return;
    invalidatePendingAttempt(matchedForm);
    var submit=matchedForm.querySelector('[type="submit"]');
    if(submit)submit.disabled=false;
    if(event.data.ok&&(event.data.code==='received'||event.data.code==='already_received')){
      var successMessage=event.data.code==='already_received'?'This request was already received. No duplicate record was created.':'Your request was received. 760 Print will review it using the published program rules.';
      if(matchedForm.dataset.intakeStage==='certification'){
        var loadId=event.data.submission_id||(matchedForm.querySelector('[name="submission_id"]')||{}).value||'';
        var presentedPanels=(matchedForm.querySelector('[name="presented_panels"]')||{}).value||'';
        savePendingIntake(loadId,presentedPanels);
        successMessage='Donor certification saved. Load ID: '+loadId+'. Keep the load with the donor until inspection is complete. Staff must use this same load ID to record the final outcome.';
        var continueButton=matchedForm.querySelector('[data-sr-continue-finalize]');
        if(continueButton)continueButton.hidden=false;
      }else if(matchedForm.dataset.intakeStage==='finalize'){
        clearPendingIntake();
        var receiptId=event.data.receipt_id||'';
        if(savePendingReceipt(event.data)){
          successMessage=(event.data.code==='already_received'?'This certified load was already finalized. No duplicate outcome was created. ':'The intake outcome was recorded. ')+'Numbered receipt ID: '+receiptId+'. Show it on screen or provide a printed copy, then record the handoff.';
          var receiptButton=matchedForm.querySelector('[data-sr-continue-receipt]');
          if(receiptButton)receiptButton.hidden=false;
        }else{
          successMessage='The intake outcome was recorded, but a complete numbered receipt was not returned. Stop and reconcile the staff record before handing over a receipt.';
        }
      }else if(matchedForm.dataset.intakeStage==='receipt_delivery'){
        clearPendingReceipt();
        successMessage=event.data.code==='already_received'?'This numbered receipt handoff was already recorded. No duplicate delivery record was created.':'The numbered receipt handoff was recorded. No intake counts or custody facts were changed.';
      }else if(matchedForm.dataset.intakeStage==='ownership_dispute_hold'){
        successMessage=event.data.code==='already_received'?'This ownership-dispute hold was already recorded. No duplicate transition was created.':'The selected accepted panels were moved to ownership-dispute hold and the dispute history was recorded. Keep them quarantined. Release, return or other resolution still requires a separate counsel-approved workflow.';
      }
      setStatus(matchedForm,successMessage,'success');
      analytics('sr_form_success',variantParams(matchedForm));
      if(matchedForm.dataset.formType==='contact')analytics('sr_contact_success',{contact_type:contactType(matchedForm)});
      matchedForm.dataset.completed='true';
      Array.prototype.forEach.call(matchedForm.elements,function(field){if(field.type!=='hidden'&&field.name!=='website_confirm'&&!field.hasAttribute('data-sr-continue-finalize')&&!field.hasAttribute('data-sr-continue-receipt'))field.disabled=true;});
    }else if(event.data.ok&&event.data.code==='accepted'){
      setStatus(matchedForm,'The request could not be confirmed. Please reload the page and try again.','error');
      analytics('sr_form_error',variantParams(matchedForm,{error_code:'unconfirmed_response'}));
    }else{
      resetTurnstile(matchedForm);
      setStatus(matchedForm,event.data.message||'The request could not be completed. Please try again.','error');
      analytics('sr_form_error',variantParams(matchedForm,{error_code:event.data.code||'server_error'}));
    }
  });

  root.addEventListener('click',function(event){
    var vote=event.target.closest('[data-sr-vote-link]');
    if(vote)analytics('sr_vote_click',{link_location:vote.dataset.ctaLocation||vote.dataset.ctaId||'program_modal'});
    var release=event.target.closest('[data-sr-press-release]');
    if(release)analytics('sr_press_release_click',{link_location:release.dataset.ctaLocation||'program_resources'});
    var resource=event.target.closest('[data-sr-resource]');
    if(resource)analytics('sr_resource_click',{resource_type:resource.dataset.srResource,link_location:resource.dataset.ctaLocation||'program_resources'});
  });

  if('IntersectionObserver' in window){
    var viewed=false;
    var observer=new IntersectionObserver(function(entries){
      if(!viewed&&entries.some(function(entry){return entry.isIntersecting;})){
        viewed=true;
        analytics('sr_program_view',{page_type:'signs_reassigned_program'});
        observer.disconnect();
      }
    },{threshold:.05});
    observer.observe(root);
  }else analytics('sr_program_view',{page_type:'signs_reassigned_program'});
})();
